/**
 * @generated SignedSource<<7bddefba16e0e3fb2655c6e8a82785c2>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af

import type { ConcreteRequest } from 'relay-runtime';
export type LicenseStatus = "ACTIVE" | "SUSPENDED" | "UNLICENSED" | "%future added value";
export type useLoomTenantProvisionStatusQuery$variables = Record<PropertyKey, never>;
export type useLoomTenantProvisionStatusQuery$data = {
  readonly confluence_tenantContext: {
    readonly licensedProducts: ReadonlyArray<{
      readonly licenseStatus: LicenseStatus;
      readonly productKey: string;
    }>;
  } | null | undefined;
};
export type useLoomTenantProvisionStatusQuery = {
  response: useLoomTenantProvisionStatusQuery$data;
  variables: useLoomTenantProvisionStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "LicensedProduct",
        "kind": "LinkedField",
        "name": "licensedProducts",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "licenseStatus"
          },
          {
            "kind": "ScalarField",
            "name": "productKey"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useLoomTenantProvisionStatusQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useLoomTenantProvisionStatusQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
    "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
    "metadata": {},
    "name": "useLoomTenantProvisionStatusQuery",
    "operationKind": "query",
    "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
  }
};
})();

(node as any).hash = "21c387cdafea215b61e4183319580a69";

export default node;
